function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import clone from 'ramda/src/clone';
import i18n from 'invision-core/src/components/i18n/i18n';
import { convertStringToNumber } from 'invision-core/src/components/helpers/conversion.helper';
import CustomerLocaleKeys from '../../../../../../../locales/keys';
import { UNIT_OF_MEASURES } from '../../../../../../../customercare.constants';
import { setSelectedPolicyCounter, updatePolicyCounterBalance } from '../..../../../../../../../../reducers/actions/edit.policy.counter.modal.actions';
import { ConvergentBillerCurrencyCodeSelector } from '../../../../../../../reducers/selectors/customer.convergent.biller.selectors';
import { retrieveServiceDetails } from '../../../../../../../reducers/actions/services.actions';
import { IsLoadingSelector, PolicyCountersSelector, UnitOfMeasuresSelector } from '../../../../../../../reducers/selectors/edit.policy.counter.modal.selectors';
export var EditPolicyCounterModalController = /*#__PURE__*/function () {
  function EditPolicyCounterModalController($ngRedux, uiNotificationService) {
    _classCallCheck(this, EditPolicyCounterModalController);
    Object.assign(this, {
      $ngRedux: $ngRedux,
      CustomerLocaleKeys: CustomerLocaleKeys,
      uiNotificationService: uiNotificationService
    });
  }
  return _createClass(EditPolicyCounterModalController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      this.disableConfirm = true;
      this.policyCountersToUpdate = [];
      this.selectedPolicyCounter = null;
      this.adjustRemainingBalanceBy = [];
      var controllerActions = {
        retrieveServiceDetails: retrieveServiceDetails,
        setSelectedPolicyCounter: setSelectedPolicyCounter,
        updatePolicyCounterBalance: updatePolicyCounterBalance
      };
      var mapStateToProps = function mapStateToProps(store) {
        return {
          currencyCode: ConvergentBillerCurrencyCodeSelector(store),
          isLoading: IsLoadingSelector(store),
          policyCounters: PolicyCountersSelector(store),
          unitOfMeasures: UnitOfMeasuresSelector(store)
        };
      };
      this.disconnectRedux = this.$ngRedux.connect(mapStateToProps, controllerActions)(function (state, actions) {
        _this.state = state;
        _this.actions = actions;
      });
      this.dropdownPolicyCounterItems = this.state.policyCounters.filter(function (policyCounter) {
        if (policyCounter.OwningSubscriberId) {
          return policyCounter.BalanceUnitCode !== UNIT_OF_MEASURES.CURRENCY && policyCounter.OwningSubscriberId === _this.currentCustomerId;
        } else {
          return policyCounter.BalanceUnitCode !== UNIT_OF_MEASURES.CURRENCY;
        }
      });
    }
  }, {
    key: "updatePolicyCounter",
    value: function updatePolicyCounter() {
      var _this2 = this;
      var updatePolicyCounterBalanceRequest = {
        AdjustmentAmount: +this.adjustRemainingBalanceBy[0].value,
        BalanceUnitCode: this.adjustRemainingBalanceBy[0].type,
        EntitlementId: +this.selectedPolicyCounter.EntitlementId,
        Reason: this.reasonDescription
      };
      this.actions.updatePolicyCounterBalance(updatePolicyCounterBalanceRequest, this.currentCustomerId).then(function () {
        var serviceIdentifiers = [{
          Value: _this2.serviceIdentifier.Value
        }];
        _this2.uiNotificationService.success(i18n.translate(_this2.CustomerLocaleKeys.CUSTOMER_DASHBOARD.SERVICES_WIDGET.EDIT_POLICY_COUNTER_MODAL.POLICY_COUNTER_BALANCE_UPDATE_SUCCESS));
        _this2.actions.retrieveServiceDetails(_this2.currentCustomerId, serviceIdentifiers);
      }).catch(function (error) {
        _this2.uiNotificationService.transientError(error.translatedMessage);
      }).finally(function () {
        _this2.cancelEditPolicyCounterModal();
      });
    }
  }, {
    key: "handleFormChanged",
    value: function handleFormChanged() {
      this.disableConfirm = !(this.adjustRemainingBalanceBy && this.reasonDescription);
    }
  }, {
    key: "cancelEditPolicyCounterModal",
    value: function cancelEditPolicyCounterModal() {
      this.actions.setSelectedPolicyCounter({});
      this.onClose();
    }
  }, {
    key: "onPolicyCounterChange",
    value: function onPolicyCounterChange() {
      this.editPolicyCounterForm.$setPristine();
      if (this.selectedPolicyCounter) {
        this.adjustRemainingBalanceBy = [{
          type: +this.selectedPolicyCounter.BalanceUnitCode,
          value: null
        }];
        this.reasonDescription = '';
        this.disableConfirm = true;
      }
      this.actions.setSelectedPolicyCounter(this.selectedPolicyCounter);
      this.uomDropdownOptions = clone(this.state.unitOfMeasures);
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.disconnectRedux();
    }
  }]);
}();
export default {
  controller: EditPolicyCounterModalController,
  controllerAs: 'EditPolicyCounterModalController',
  template: require('./edit.policy.counter.html'),
  bindings: {
    currentCustomerId: '<',
    onClose: '&',
    serviceIdentifier: '<'
  }
};